import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import {
	Row,
	Col,
	Card,
	BackTop,
	Table,
	Tooltip,
	Space,
	Breadcrumb,
	Tabs,
	Button
} from "antd";
import { fetchAdminApi, } from "../../../services/api";
import moment from 'moment';
import constants from '../../../constants/constants';
import { useHistory } from "react-router";
import { FileSearchOutlined, StarFilled } from '@ant-design/icons';
const StudentAllActivities = () => {
	const history = useHistory();
	const [studentActivitiesData, setStudentActivitiesData] = useState();
	const [accountActivitiesData, setAccountActivitiesData] = useState([]);
	const [totalPoints, setTotalPoints] = useState(0);
	const [dataLength, setDataLength] = useState(0);
	const [tokenValue,setTokenValue]=useState();
	const [testTypeTotal, setTestTypeTotal] = useState({
		total_tests_points:0,
		total_tutorials_points:0,
		total_flashcards_points:0,
		total_feedback_points:0,
		total_qod_points:0
	});
	const pagination = { showSizeChanger: true, };
	const { TabPane } = Tabs;
	const handleViewResult = (record) => {
		if (record?.test === "Full length") {
			let obj =  { 
				scoreCardId:record?.score_card_id,
				isReview:"t",
				userId:record?.stud_id,
				fromTestResult:true,
				returnTest:"Test Results"
			};
			sessionStorage.setItem("TestresultObject", JSON.stringify(obj));
			window.open(constants.BaseUrl+"/full-length-result-page", '_blank');
		} else if (record?.test?.startsWith("Tutorial")) {
			let reviewTutorial={};
			reviewTutorial.studId =record?.stud_id;
			reviewTutorial.scoreCardId=record?.score_card_id;
			reviewTutorial.review="tutorial";
			reviewTutorial.fromTutorialResult=true;
			reviewTutorial.totalCorrectAnswers=record?.total_corr_ans ? record?.total_corr_ans:"";
			reviewTutorial.totalTestQuestions=record?.total_test_que ? record?.total_test_que : "";
			if(record?.test === "Tutorial - Category"){
				reviewTutorial.categoryId=record?.category_id;
				reviewTutorial.type="category";
			}
			if(record?.test === "Tutorial - Topic"){
				reviewTutorial.topicId=record?.topic_id;
				reviewTutorial.type="topic";
			}
			if(record?.test === "Tutorial - Custom"){
				reviewTutorial.type="custom";
			}
			if(record?.test !== "Tutorial - Topic"){
				reviewTutorial.attempt=record?.attempts;
			}
			sessionStorage.setItem("TutorialresultObject", JSON.stringify(reviewTutorial));
			window.open(constants.BaseUrl+"/review-tutorial", '_blank');
		} else {
			let obj = { 
				scoreCardId:record?.score_card_id,
				resultTypeFull:record?.test ==="Topic" || record?.test_type === "MIXED"? false : true,
				testCategory:record?.test ==="Topic"? null : record?.test_type,
				isTopic:record?.test === "Topic" ? true : false,
				isReview:"t",
				userId:record?.stud_id,
				fromTestResult:true,
				returnTest:"Test Results"
			};
			sessionStorage.setItem("TestresultObject", JSON.stringify(obj));
			window.open(constants.BaseUrl+"/test-result", '_blank');
		}
	};
	const studentActivitiesColumn = [
		{
			title: 'Date',
			key: 'date',
			dataIndex: 'date',
			width: '150px',
			align: 'left',
			render: (value, record) => {
				return (<Tooltip title={record?.time}><span>{moment(value).format(constants.dateFormat)}</span></Tooltip>);
			},
		},
		{
			title: 'Question ID',
			key: 'qod_qid',
			dataIndex: 'qod_qid',
			align: 'center',
			render:(record) =>{
				if(record !== null){
					return <span>{record}</span>;
				}
			}
		},
		{
			title: 'Activity Type',
			key: 'Tests',
			render: (record) => {
				let activityType = "";
				if(record?.type === "0"){
					if(record?.test_type === "TOPIC"){
						activityType = "Test - Topic";
					}
					else if(record?.test_type === "TEST"){
						activityType = "Test - Full Length";
					}
					else {
						activityType = "Test - Category";
					}
				}else if(record?.type === "1"){
					if(record?.test_type === "TOPIC"){
						activityType = "Tutorial - Topic";
					}else{
						activityType = "Tutorial - Category";
					}
				}else if(record?.type === "2"){
					if(record?.topic_id){
						activityType = "Flashcard - Topic";
					}else{
						activityType = "Flashcard - Textbook";
					}
				}else if(record?.type === "3"){
					activityType = "Feeback";
				}else if(record?.type === "4"){
					activityType = "QOD";
				}
				return <span>{activityType}</span>;
			},
		},
		{
			title: 'Test Type',
			key: 'Type',
			render: (record) => {
				let testType="";
				let title = "";
				if(record?.type === "0"){
					if(record?.test_type === "TOPIC"){
						testType = record?.topic_abb;
						title = record?.topic;
					}else if(record?.test_type === "TEST"){
						testType="Full Length #"+record?.attempts;
					}
					else{
						testType = record?.test_type+" #"+record?.attempts;
					}
					// return <Tooltip title={title}>
					// 	<span>{record?.points}</span>
					// </Tooltip>;
				}
				else if(record?.type === "1"){
					if(record?.test_type === "TOPIC"){
						testType = record?.topic_abb;
						title = record?.topic;
					}else{
						if(record.test_type==="MARK FOR LATER"||record.test_type==="INCORRECT ANS"){
							testType = record?.test_type;
						}else{
							testType = record?.test_type+" #"+record?.attempts;
						}
					}
				}
				else if(record?.type === "2"){
					if(record?.topic_id){
						testType = record?.topic_abb;
						title = record?.topic;
					}else{
						testType = record?.chapter_abb?record.chapter_abb:record.chapter;
						title = record?.chapter;
					}
				}
				else if(record?.type === "3"){
					testType = "Feedback";
				}
				else if(record?.type === "4"){
					testType = record?.question?.length<35?record.question:record.question.substring(0,35)+"...";
					title = record?.question;
				}
				return <Tooltip title={ title }>
					<span style = {{ width:"90px" }}>{testType}</span>
				</Tooltip>;
			},
		},
		{
			title: (
				<Tooltip title="View Result">
					<span>VR</span>
				</Tooltip>
			),
			key: "score_card_id",
			dataIndex: "score_card_id",
			align: "center",
			render: (scoreCardId, record) => (
				<Space>
					{scoreCardId ? (
						<Tooltip title="View Result">
							<Button
								type="link"
								icon={<FileSearchOutlined/>}
								onClick={() => handleViewResult(record)}
							/>
						</Tooltip>
					) : null}
				</Space>
			),
		},
		{
			title: 'Score',
			key: 'marks_scored',
			align: 'center',
			dataIndex: 'marks_scored',
			render: (value) => <span>{value}</span>,
		},
		{
			title: 'Points',
			key: 'points',
			align: 'center',
			dataIndex: 'points',
			render:(record) =>{
				if(record !=="0"){
					return <span>{record}</span>;
				}
			}
		},
		{
			title: 'Result',
			key: 'percent_scored',
			align: 'center',
			dataIndex: 'percent_scored',
			className: 'td-right result-col center-star',
			render: (value, record) => (
				<div>
					<span className={record?.test_result === "PASS" ? "p-relative d-flex" : ""}>
						{value != null && `${value}%`} {record?.test_result === "PASS" && (
							<StarFilled className="yellow ml-2"/>
						)}
					</span>
				</div>
			),
		},
		{
			title: 'Attempt',
			key: 'attempts',
			align: 'center',
			dataIndex: 'attempts',
			render:(text,record) =>{
				if(text !=="0"){
					if(record?.is_retake==="t"){
						return <span>2</span>;
					}else{
						return <span>1</span>;
					}
				}
			}
		},
		{
			title: 'Retake',
			key: 'retake',
			align: 'center',
			dataIndex :"is_retake",
			render: (record) => {
				if(record === "t"){
					return <span>Yes</span>;
				}else{
					return ("");
				}
			},
		},
		// {
		// 	title: 'Points Earned',
		// 	key: 'points',
		// 	dataIndex: 'points',
		// 	className: 'td-right',
		// 	align: 'center',
		// 	render: (record) => {
		// 		return (<span>{record}</span>);
		// 	},
		// },
	];
	const parseUserAgent = (ua = "") => {
		if (!ua || typeof ua !== "string") {
			return {
				browser: "-",
				browserVersion: "-",
				os: "-",
				osVersion: "-",
				deviceType: "-",
			};
		}
		let browser = "Unknown";
		let browserVersion = "-";
		let os = "Unknown";
		let osVersion = "-";
		let deviceType = "Desktop";
		// ---------------- Browser ----------------
		if (/EdgiOS\/([\d.]+)/i.test(ua)) {
			browser = "Edge";
			browserVersion = ua.match(/EdgiOS\/([\d.]+)/i)?.[1] || "-";
		} else if (/Edg\/([\d.]+)/i.test(ua)) {
			browser = "Edge";
			browserVersion = ua.match(/Edg\/([\d.]+)/i)?.[1] || "-";
		} else if (/FxiOS\/([\d.]+)/i.test(ua)) {
			browser = "Firefox";
			browserVersion = ua.match(/FxiOS\/([\d.]+)/i)?.[1] || "-";
		} else if (/Firefox\/([\d.]+)/i.test(ua)) {
			browser = "Firefox";
			browserVersion = ua.match(/Firefox\/([\d.]+)/i)?.[1] || "-";
		} else if (/CriOS\/([\d.]+)/i.test(ua)) {
			browser = "Chrome";
			browserVersion = ua.match(/CriOS\/([\d.]+)/i)?.[1] || "-";
		} else if (/Chrome\/([\d.]+)/i.test(ua) && !/Edg/i.test(ua)) {
			browser = "Chrome";
			browserVersion = ua.match(/Chrome\/([\d.]+)/i)?.[1] || "-";
		} else if (/Version\/([\d.]+).*Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/i.test(ua)) {
			browser = "Safari";
			browserVersion = ua.match(/Version\/([\d.]+)/i)?.[1] || "-";
		}
		// ---------------- OS ----------------
		if (/iPhone OS ([\d_]+)/i.test(ua)) {
			os = "iOS";
			osVersion = ua.match(/iPhone OS ([\d_]+)/i)?.[1]?.replace(/_/g, ".") || "-";
			deviceType = "Mobile";
		} else if (/iPad.*OS ([\d_]+)/i.test(ua)) {
			os = "iOS";
			osVersion = ua.match(/OS ([\d_]+)/i)?.[1]?.replace(/_/g, ".") || "-";
			deviceType = "Tablet";
		} else if (/Android ([\d.]+)/i.test(ua)) {
			os = "Android";
			osVersion = ua.match(/Android ([\d.]+)/i)?.[1] || "-";
			deviceType = /Mobile/i.test(ua) ? "Mobile" : "Tablet";
		} else if (/Windows NT 10.0/i.test(ua)) {
			os = "Windows";
			osVersion = "10";
		} else if (/Windows NT 11.0/i.test(ua)) {
			os = "Windows";
			osVersion = "11";
		} else if (/Mac OS X ([\d_]+)/i.test(ua)) {
			os = "macOS";
			osVersion = ua.match(/Mac OS X ([\d_]+)/i)?.[1]?.replace(/_/g, ".") || "-";
		}
		// ---------------- Device ----------------
		if (/iPad|Tablet/i.test(ua)) {
			deviceType = "Tablet";
		} else if (/Mobile|iPhone|Android/i.test(ua)) {
			deviceType = "Mobile";
		} else if (!["Mobile", "Tablet"].includes(deviceType)) {
			deviceType = "Desktop";
		}
		// ---------------- IP Address ----------------
		let ipAddress = "";
		const ipMatch = ua.match(/ip:\s*([^\s]+)/i);
		if (ipMatch) {
			ipAddress = ipMatch[1];
		}
		return {
			browser,
			browserVersion,
			os,
			osVersion,
			deviceType,
			ipAddress,
		};
	};
	const accountActivitiesColumn = [
		{
			title: "Date",
			key: "created_at",
			dataIndex: "created_at",
			width: "150px",
			align: "left",
			render: (value, record) => (
				<Tooltip title={record.time}><span>{moment(value).format(constants.dateFormat)}</span></Tooltip>
			),
		},
		{
			title: "Activity Type",
			key: "activity_type",
			dataIndex: "activity_type",
			render: (text) => <span>{text || "-"}</span>,
		},
		{
			title: "Activity Data",
			key: "activity_data",
			dataIndex: "activity_data",
			render: (text) => {
				if (!text || text === "[]") return <span>-</span>;
				try {
					const parsed = typeof text === "string" ? JSON.parse(text) : text;
					if (
						!parsed ||
          (Array.isArray(parsed) && parsed.length === 0) ||
          (typeof parsed === "object" && Object.keys(parsed).length === 0)
					) {
						return <span>-</span>;
					}
					if (parsed?.Browser) {
						const uaData = parseUserAgent(parsed.Browser);
						return (
							<div>
								<span>{uaData.browser}{" "}-{" "}{uaData.browserVersion},{" "}{uaData.deviceType ? uaData.deviceType : " "}{" "}-{" "}{uaData.osVersion !== "-" ? uaData.osVersion : ""}{uaData.ipAddress ? `, ${uaData.ipAddress}` : ""}</span>
							</div>
						);
					}
					return (
						<div>
							{Object.entries(parsed).map(([key, value]) => (
								<div key={key}>
									<strong>{key}:</strong> {String(value)}
								</div>
							))}
						</div>
					);
				} catch (error) {
					return <span>{text}</span>;
				}
			},
		},
	];
	useEffect(() => {
		let token = sessionStorage.getItem("studentId");
		setTokenValue(token);
		fetchStudentActivitesdata(token);
		fetchActivitesdata(token);
	}, []);
	const fetchStudentActivitesdata =(token)=>{
		fetchAdminApi(`/total-activities-points/${token}`, "get").then((res) => {
			if (res && res.data) {
				setStudentActivitiesData(res?.data);
				setTotalPoints(res?.data?.result[0]?.total_points);
				setTestTypeTotal({ 
					...testTypeTotal,
					total_tests_points:res?.data?.total_tests_points,
					total_tutorials_points:res?.data?.total_tutorials_points,
					total_flashcards_points:res?.data?.total_flashcards_points,
					total_feedback_points:res?.data?.total_feedback_points,
					total_qod_points:res?.data?.total_qod_points,
				});
			}else{
				setStudentActivitiesData([]);
			}
		});
	};
	const fetchActivitesdata =(token)=>{
		fetchAdminApi(`/student-activity/${token}`, "get").then((res) => {
			if (res && res.data) {
				setAccountActivitiesData(res?.data);
				setDataLength(res.data.length);
			}else{
				setAccountActivitiesData([]);
				setDataLength(0);
			}
		});
	};
	return (
		<>
			<div className='gray-bg'>
				<div className='p-4'>
					<BackTop/>
					<Breadcrumb>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/admin-dashboard" });
						}}>Home</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/analysis-menu" });
						}}>Analysis</a></Breadcrumb.Item>
						<Breadcrumb.Item><a onClick={() => {
							sessionStorage.setItem("showEditSaveButton","show");
							history.push({ pathname:"/edit-student", });
						}}>Edit Student User</a></Breadcrumb.Item>
						<Breadcrumb.Item>
						Student Activities</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<Row gutter={[24, 24]} >
					<Col xs={24} sm={24} md={24} lg={24}>
						<Card size="small" title={<><span className="text-uppercase">Student Activities - {studentActivitiesData?.name}</span>
							<span style={{ visibility:"hidden" }}>{" "}Student ID:{tokenValue}</span></>
						} 
						extra={<span>Username: {studentActivitiesData?.login_username}</span>}
						>
							<Tabs defaultActiveKey="1" type="card" size="small">
								<TabPane tab={constants.LearningActivities} key="1">		
									<p>Total Points Earned: {totalPoints}</p>
									<Table className="admin-gap-table" 
										locale={{ emptyText: 'No Records Found' }}
										dataSource={studentActivitiesData?.result} 
										columns={studentActivitiesColumn}
										pagination={pagination}
									/>
									<div className="div-below-grid">
										<Space direction="horizontal">
											<span>Total Test Points: <b>{testTypeTotal?.total_tests_points}</b></span>
											<span>Total Tutorial Points: <b>{testTypeTotal?.total_tutorials_points}</b></span>
											<span>Total Flashcard Points: <b>{testTypeTotal?.total_flashcards_points}</b></span>
											<span>Total Feedback Points: <b>{testTypeTotal?.total_feedback_points}</b></span>
											<span>Total QOD Points: <b>{testTypeTotal?.total_qod_points}</b></span>
										</Space>
									</div>
								</TabPane>
								<TabPane tab={constants.AccountActivities} key="2">
									<span className="p-1">{dataLength !== null ? `${dataLength} record(s) found.` : ""}</span>
									<Table className="admin-gap-table" 
										locale={{ emptyText: 'No Records Found' }}
										dataSource={accountActivitiesData} 
										columns={accountActivitiesColumn}
										pagination={pagination}
									/>
								</TabPane>
							</Tabs>
						</Card>
					</Col>
				</Row> 
			</div>
		</>
	);
};
export default StudentAllActivities;
